let xlsxPromise = null;

export const loadXLSX = () => {
  if (typeof window === 'undefined') {
    return Promise.resolve(null);
  }

  if (window.XLSX) {
    return Promise.resolve(window.XLSX);
  }

  if (!xlsxPromise) {
    xlsxPromise = new Promise((resolve, reject) => {
      const existingScript = document.querySelector('script[data-xlsx-loader]');
      if (existingScript) {
        existingScript.addEventListener('load', () => resolve(window.XLSX));
        existingScript.addEventListener('error', () => reject(new Error('Failed to load XLSX library')));
        return;
      }

      const script = document.createElement('script');
      script.src = 'https://cdn.jsdelivr.net/npm/xlsx@0.18.5/dist/xlsx.full.min.js';
      script.async = true;
      script.setAttribute('data-xlsx-loader', 'true');
      script.onload = () => resolve(window.XLSX);
      script.onerror = () => reject(new Error('Failed to load XLSX library'));
      document.body.appendChild(script);
    });
  }

  return xlsxPromise;
};

